import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './admin/context/AuthContext';
import { StyleProvider, useStyle } from './context/StyleContext';
import AdminApp from './admin/AdminApp';
import ClientApp from './ClientApp';

function App() {
    return (
        <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/*" element={<ClientApp />} />
        </Routes>
    );
}

export default App;